export const QUERY = `
  query getBindUnitAccountDetails(
    $token: String!
    ) {
    getBindUnitAccountDetails (
      token: $token
      ){
        customerId
        companyName
        billId
        returnUrl
        meta
        bindUrl
        linkToken
        counterPartyId
        isRelinked
      }
  }
`;
